<template>
  <div class="chat-window" v-loading="loading" element-loading-text="加载中..."
       element-loading-background="rgba(255, 255, 255, 0.8)">
    <!-- 聊天窗口顶部 -->
    <div class="chat-header">
      <div class="chat-info">
        <span class="chat-name">{{ chat.otherPhone }}</span>
        <!-- <span class="chat-status">{{ chat.type === 'group' ? `${chat.memberCount}人` : '在线' }}</span> -->
      </div>
      <div class="header-actions">
        <i class="el-icon-more"></i>
      </div>
    </div>

    <!-- 聊天消息区域 -->
    <div class="chat-messages" ref="messageContainer">
      <div v-for="msg in messages" :key="msg.id" :class="['message-item', msg.isSelf ? 'self' : 'other']">
        <el-avatar :size="40"
                   :style="msg.isSelf ? { background: 'linear-gradient(135deg, #7366ff 0%, #a388ff 100%)' } : { background: 'linear-gradient(135deg, #fd3c97 0%, #f97794 100%)' }">
          {{ msg.isSelf ? "我" : "他" }}
        </el-avatar>
        <div class="message-content">
          <div class="message-info">
            <span class="sender">{{
                msg.isSelf ? `${username}:${msg.sender}-${msg.phonenumber}` : msg.othernumber
              }}</span>
            <span class="time">{{ msg.time }}</span>
          </div>
          <div class="message-bubble" :class="{ 'failed': msg.status === 'Failed' }">
            <div class="message-text">{{ msg.content }}</div>

            <!-- 消息状态图标 -->
            <!--            <div v-if="msg.status === 'FAILED' || msg.status === 'Failed'" class="status-icon failed"-->
            <!--                 @click="resendMessage(msg)">-->
            <!--              <i class="el-icon-warning"></i>-->
            <!--              <div class="status-tooltip">发送失败，点击重发</div>-->
            <!--            </div>-->

            <!--            <div v-else-if="msg.status === 'PEDNDING' || msg.status === 'Pending'" class="status-icon pending"-->
            <!--                 @click="refreshMessageStatus(msg)">-->
            <!--              <i class="el-icon-time"></i>-->
            <!--              <div class="status-tooltip">等待中，点击刷新状态</div>-->
            <!--            </div>-->

            <!--            <div v-else-if="msg.status === 'PRECESSED' || msg.status === 'Processed'" class="status-icon processed"-->
            <!--                 @click="refreshMessageStatus(msg)">-->
            <!--              <i class="el-icon-loading"></i>-->
            <!--              <div class="status-tooltip">已处理，点击刷新状态</div>-->
            <!--            </div>-->

            <!--            <div v-else-if="msg.status === 'SENT' || msg.status === 'Sent'" class="status-icon sent"-->
            <!--                 @click="refreshMessageStatus(msg)">-->
            <!--              <i class="el-icon-upload2"></i>-->
            <!--              <div class="status-tooltip">已发送，点击刷新状态</div>-->
            <!--            </div>-->

            <!--            <div v-else-if="msg.status === 'DELIVERED' || msg.status === 'Delivered'" class="status-icon delivered">-->
            <!--              <i class="el-icon-success"></i>-->
            <!--              <div class="status-tooltip">已成功送达</div>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
    </div>

    <!-- 聊天输入区域 -->
    <div class="chat-input">
      <el-input v-model="inputMessage" type="textarea" :rows="3" placeholder="输入消息..."
                @keyup.enter.native="sendMessage"></el-input>
      <el-button type="primary" @click="sendMessage">发送</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatWindow',
  props: {
    chat: {
      type: Object,
      required: true
    }
  },
  watch: {
    chat: {
      immediate: true,
      deep: true,
      handler(newChat) {
        if (newChat) {
          this.queryChatRecord()
        }
      }
    }
  },
  data() {
    return {
      loading: false,
      inputMessage: '',
      messages: [],
      username: localStorage.getItem('username') || '用户'
    }
  },
  mounted() {
    this.$bus.$on('NEW_MESSAGE', () => {
      console.log('new message');
      this.queryChatRecord()
    })
    this.queryChatRecord()
  },
  methods: {
    queryChatRecord() {
      this.loading = true
      this.$http.get("/sms/info/queryChatRecord/" + this.chat.otherPhone)
          .then(res => {
            if (res.code == 200) {
              this.messages = res.data.chatRecord
              this.$emit('query')
              this.scrollToBottom()
            } else {
              this.$message.error(res.msg)
            }
          }).finally(() => {
        this.loading = false
      })
    },
    sendMessage() {
      if (!this.inputMessage.trim()) {
        this.$message.warning('请输入消息内容')
        return
      }

      const formData = new FormData()
      formData.append('phone', this.chat.otherPhone)
      formData.append('content', this.inputMessage)

      this.$http.post("/sms/info/sendSms", formData, {
        headers: {
          'Content-Type': 'multipart/form-data;boundary=' + Math.random().toString().substr(2)
        }
      })
          .then(res => {
            if (res.code == 200) {
              this.$message.success('发送成功')
              this.queryChatRecord()
              this.$emit('send-success')
            } else {
              this.$message.error(res.msg)
            }
          })

      this.inputMessage = ''
    },
    resendMessage(msg) {
      this.$confirm('确定要重新发送这条消息吗？', '重发确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
        customClass: 'custom-message-box',
        distinguishCancelAndClose: true,
        confirmButtonClass: 'custom-confirm-button',
        cancelButtonClass: 'custom-cancel-button',
        showClose: false,
        center: true
      }).then(() => {
        this.loading = true
        const formData = new FormData()
        formData.append('phone', this.chat.otherPhone)
        formData.append('content', msg.content)

        this.$http.post("/sms/info/sendSms", formData, {
          headers: {
            'Content-Type': 'multipart/form-data;boundary=' + Math.random().toString().substr(2)
          }
        })
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: '重发成功',
                  customClass: 'custom-message'
                })
                this.queryChatRecord()
                this.$emit('send-success')
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg,
                  customClass: 'custom-message'
                })
              }
            }).finally(() => {
          this.loading = false
        })
      }).catch(() => {
        // 用户取消操作
      })
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messageContainer
        if (container) {
          container.scrollTop = container.scrollHeight
        }
      })
    },
    refreshMessageStatus(msg) {
      if (!msg.messageId) {
        this.$message.warning('无法刷新状态：消息ID不存在');
        return;
      }
      // 加载中
      this.loading = true
      this.$http.get(`/sms/info/refreshStatus/${msg.messageId}`)
          .then(res => {
            if (res.code === 200) {
              this.$message.success('状态已更新');
              this.queryChatRecord();
            } else {
              this.$message.error(res.msg || '刷新状态失败');
            }
          })
          .catch(err => {
            this.$message.error('刷新状态失败: ' + (err.message || '未知错误'));
          }).finally(() => {
        this.loading = false
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-window {
  width: 100%;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.95);
  margin: 16px;
  border-radius: 24px;
  box-sizing: border-box;
  box-shadow: 0 10px 30px rgba(115, 102, 255, 0.1);
  overflow: hidden;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(115, 102, 255, 0.15);

  .chat-header {
    padding: 18px 20px;
    background: linear-gradient(135deg, #ffffff 0%, #f9faff 100%);
    border-bottom: 1px solid rgba(115, 102, 255, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .chat-info {
      .chat-name {
        font-size: 18px;
        font-weight: 600;
        color: #1e293b;
      }

      .chat-status {
        margin-left: 8px;
        font-size: 12px;
        color: #64748b;
      }
    }

    .header-actions {
      display: flex;
      gap: 16px;

      i {
        font-size: 20px;
        color: #7366ff;
        cursor: pointer;
        transition: all 0.2s;

        &:hover {
          color: #a388ff;
          transform: scale(1.1);
        }
      }
    }
  }

  .chat-messages {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    background: linear-gradient(135deg, #f6f8fc 0%, #f3f4fa 100%);
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      opacity: 0.5;
      z-index: 0;
    }

    .message-item {
      display: flex;
      margin-bottom: 24px;
      gap: 14px;
      position: relative;
      z-index: 1;

      &.self {
        flex-direction: row-reverse;

        .message-content {
          align-items: flex-end;

          .message-text {
            line-height: 1.5;
            font-size: 14px;
            color: #fff;
          }

          .message-bubble {
            background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
            color: white;
            border-radius: 20px 4px 20px 20px;
            box-shadow: 0 4px 15px rgba(115, 102, 255, 0.2);
            max-width: 80%;
            min-width: 100px;

            &.failed {
              position: relative;
            }

            .status-icon {
              position: absolute;
              top: 50%;
              left: -34px;
              transform: translateY(-50%);
              width: 26px;
              height: 26px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
              transition: all 0.3s;
              z-index: 2;
              background: white;

              .status-emoji {
                font-size: 16px;
                line-height: 1;
              }

              i {
                color: #7C6CFF;
                font-size: 20px;
                font-weight: bold;
              }

              &:hover .status-tooltip {
                opacity: 1;
                transform: translateX(-50%) translateY(-100%) scale(1);
              }

              .status-tooltip {
                position: absolute;
                top: -5px;
                left: 50%;
                transform: translateX(-50%) translateY(-100%) scale(0.9);
                background: rgba(0, 0, 0, 0.8);
                color: white;
                padding: 5px 10px;
                border-radius: 8px;
                font-size: 12px;
                white-space: nowrap;
                opacity: 0;
                transition: all 0.2s ease;
                pointer-events: none;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

                &::after {
                  content: '';
                  position: absolute;
                  bottom: -4px;
                  left: 50%;
                  transform: translateX(-50%);
                  width: 0;
                  height: 0;
                  border-left: 5px solid transparent;
                  border-right: 5px solid transparent;
                  border-top: 5px solid rgba(0, 0, 0, 0.8);
                }
              }

              &.failed {
                background: white;
                cursor: pointer;

                &:hover {
                  transform: translateY(-50%) scale(1.1);
                  box-shadow: 0 4px 12px #7f6eff79;
                }

                &:active {
                  transform: translateY(-50%) scale(0.95);
                }
              }

              &.pending, &.processed, &.sent {
                background: white;
                cursor: pointer;

                &:hover {
                  transform: translateY(-50%) scale(1.1);
                  box-shadow: 0 4px 12px rgba(115, 102, 255, 0.4);
                }

                &:active {
                  transform: translateY(-50%) scale(0.95);
                }
              }
            }
          }
        }
      }

      .message-content {
        display: flex;
        flex-direction: column;
        max-width: 70%;

        .message-info {
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          gap: 8px;

          .sender {
            font-size: 13px;
            color: #4a5568;
            font-weight: 500;
          }

          .time {
            font-size: 12px;
            color: #64748b;
          }
        }

        .message-bubble {
          padding: 14px 18px;
          background: linear-gradient(135deg, rgb(253, 60, 151) 0%, rgb(249, 119, 148) 100%);
          border-radius: 4px 20px 20px 20px;
          position: relative;
          word-break: break-word;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
          max-width: 80%;
          min-width: 100px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

          &.failed {
            position: relative;
          }

          .message-text {
            line-height: 1.5;
            font-size: 14px;
            color: #fff;
          }

          .status-icon {
            position: absolute;
            top: 50%;
            right: -34px;
            transform: translateY(-50%);
            width: 26px;
            height: 26px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
            transition: all 0.3s;
            z-index: 2;
            background: white;

            .status-emoji {
              font-size: 16px;
              line-height: 1;
            }

            i {
              color: #ff3e6c;
              font-size: 20px;
              font-weight: bold;
            }

            &:hover .status-tooltip {
              opacity: 1;
              transform: translateX(-50%) translateY(-100%) scale(1);
            }

            .status-tooltip {
              position: absolute;
              top: -5px;
              left: 50%;
              transform: translateX(-50%) translateY(-100%) scale(0.9);
              background: rgba(0, 0, 0, 0.8);
              color: white;
              padding: 5px 10px;
              border-radius: 8px;
              font-size: 12px;
              white-space: nowrap;
              opacity: 0;
              transition: all 0.2s ease;
              pointer-events: none;
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

              &::after {
                content: '';
                position: absolute;
                bottom: -4px;
                left: 50%;
                transform: translateX(-50%);
                width: 0;
                height: 0;
                border-left: 5px solid transparent;
                border-right: 5px solid transparent;
                border-top: 5px solid rgba(0, 0, 0, 0.8);
              }
            }

            &.failed {
              background: white;
              cursor: pointer;

              &:hover {
                transform: translateY(-50%) scale(1.1);
                box-shadow: 0 4px 12px rgba(255, 62, 108, 0.4);
              }

              &:active {
                transform: translateY(-50%) scale(0.95);
              }
            }

            &.pending, &.processed, &.sent {
              background: white;
              cursor: pointer;

              &:hover {
                transform: translateY(-50%) scale(1.1);
                box-shadow: 0 4px 12px rgba(115, 102, 255, 0.4);
              }

              &:active {
                transform: translateY(-50%) scale(0.95);
              }
            }
          }
        }
      }
    }
  }

  .chat-input {
    background: white;
    padding: 18px 20px;
    border-top: 1px solid rgba(115, 102, 255, 0.1);

    :deep(.el-textarea__inner) {
      border: none;
      background: #f6f8fc;
      border-radius: 16px;
      padding: 14px 18px;
      min-height: 60px;
      box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);

      &:focus {
        box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05), 0 0 0 2px rgba(115, 102, 255, 0.2);
      }
    }

    .el-button {
      margin-top: 10px;
      float: right;
      background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
      border: none;
      border-radius: 12px;
      padding: 12px 22px;
      box-shadow: 0 4px 10px rgba(115, 102, 255, 0.3);
      transition: all 0.3s;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 15px rgba(115, 102, 255, 0.4);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }
}

:deep(.el-loading-mask) {
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
  border-radius: 24px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>

<style lang="scss">
// 全局样式，自定义提示框
.custom-message-box {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: none;

  .el-message-box__header {
    background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
    padding: 15px 20px;

    .el-message-box__status.el-icon-info {
      color: white !important;
    }

    .el-message-box__title {
      color: white !important;
      font-size: 16px;
      font-weight: 600;
    }

    .el-message-box__headerbtn {
      .el-message-box__close {
        color: rgba(255, 255, 255, 0.9);

        &:hover {
          color: white;
        }
      }
    }
  }

  .el-message-box__content {
    padding: 20px;

    .el-message-box__message {
      font-size: 14px;
      color: #4a5568;
      padding-left: 0;

      p {
        margin: 0;
        line-height: 1.6;
      }
    }

    .el-message-box__status {
      display: none;
    }
  }

  .el-message-box__btns {
    padding: 10px 20px 20px;

    .el-button {
      border-radius: 12px;
      padding: 10px 20px;
      font-size: 14px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      border: none;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
    }

    .custom-confirm-button {
      background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
      color: white;
      box-shadow: 0 4px 10px rgba(115, 102, 255, 0.3);

      &:hover {
        box-shadow: 0 6px 15px rgba(115, 102, 255, 0.4);
      }
    }

    .custom-cancel-button {
      background: #f8f9fa;
      color: #4a5568;
      margin-right: 12px;

      &:hover {
        background: #e9ecef;
      }
    }
  }
}

.custom-message {
  border-radius: 12px;
  min-width: 240px;
  border: none;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);

  &.el-message--success {
    background: linear-gradient(135deg, rgba(115, 102, 255, 0.9) 0%, rgba(163, 136, 255, 0.9) 100%);

    .el-message__content {
      color: white;
    }

    .el-message__icon {
      color: white;
    }
  }

  &.el-message--error {
    background: linear-gradient(135deg, rgba(253, 60, 151, 0.9) 0%, rgba(249, 119, 148, 0.9) 100%);

    .el-message__content {
      color: white;
    }

    .el-message__icon {
      color: white;
    }
  }

  .el-message__content {
    font-size: 14px;
    font-weight: 500;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    z-index: -1;
  }
}
</style>
